 import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
 import moment from 'moment'
export default {
    name: 'conduite-a-tenir',
    components: {
    },
    props: ['consultation', 'is_printable'],
    data () {
        return {
            vm_state: open_menu_state, 
            liste_cat: [],
            nb_jour: 0,
            cat_loading: true,
            selectedConduite: null,
            selectedMoment: null,
            nombre_jour_cat: 0
        }
    },
    computed: {
        produitInjectables() {
            return this.$store.getters['injections']
        },

        produitConsommables() {
            return this.$store.getters['consommables']
        },

        /**
         * 
         * @returns 
         */
        cat(){
            return this.$store.getters['cat'];
        },
        protocolesSoins(){
            this.nombre_jour_cat = this.$store.getters['protocolesSoinsHistorique'].nb_jour_cat

            return this.$store.getters['protocolesSoinsHistorique'].cat
        },
    },
    mounted () {
            

            this.$store.dispatch('getCurrCat', { consultation_id: this.consultation.id, date_cat: '' }).then(() => {
                this.cat_loading = false;
            })

            this.$store.dispatch("getProtocolesSoins", {id: this.consultation.id,enCours:false}).then(
                ()=>{
                    this.cat_loading = false;
                    console.log("PROTOCOLES SOINS ",this.protocolesSoins)
                }
            )
        
        
    },
    methods: {
        assignDate(){
            this.date = new Date()

        },
        /**
         * Rafraichir Conduite à tenir
         */
        refreshCAT()
        {
            this.$store.dispatch('getProtocolesSoins', { id: this.consultation.id })
            /* this.$store.dispatch('getCurrCat', { consultation_id: this.consultation_id, date_cat: '' }).then(() => {
                console.log("--< ", this.cat)
            }); */
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) 
        {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
        */
        async closeMenu(selector, show_in, show_out) 
        {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        /**
         * Traiter une conduite
         * @param {*} t_cat 
         */
        editCAT: function(t_cat, ccat){
            this.selectedConduite = t_cat
            this.selectedMoment = ccat
            for(var i=0;i< this.selectedMoment.produits.length; i++)
            {
                for(var j=0;j < this.produitInjectables.length; j++)
                {
                    if(this.selectedMoment.produits[i].libelle == this.produitInjectables[j].libelle)
                    {
                        this.selectedMoment.produits[i].prod = this.produitInjectables[j]
                    }
                }
            }

            console.log("--> ",this.selectedConduite)
        },
        formatDate: function(dateStr){
            let date = new Date(dateStr)
            let dd = (date.getDate() <= 9)?'0'+date.getDate():date.getDate();
            let mm = ((date.getMonth() + 1) <= 9)?'0'+(date.getMonth() + 1):(date.getMonth() + 1);
            let y = date.getFullYear();

            return dd + '-' + mm + '-' + y;        
        },
        formatHours: function(dateStr){
            let date = new Date(dateStr)
            let min =  (date.getMinutes() <= 9)?'0'+date.getMinutes():date.getMinutes();
            let hours =  (date.getHours() <= 9)?'0'+date.getHours():date.getHours();
            return hours +':'+ min 
        },
        computeHoursDifference: function(date){
            let dateEnd = moment(new Date(date))

            let dateStart = moment(this.protocolesSoins[0].date_heure)

            let dateDiff = dateEnd.diff(dateStart,'hours')


            return dateDiff;
            
        },
        properJson(data){
            

            try {
               return JSON.parse(data)
            } catch(e){
                return data
            }
        }
    }
}


